import { Howl, Howler } from 'howler';


//AUDIO
let intro, water, train, ending;
let currentSound;
let waterIsPlaying = false;

let soundsPreloaded = 0;

export const sounds = {
    INTRO: 'INTRO',
    WATER: 'WATER',
    TRAIN: 'TRAIN',
    ENDING: 'ENDING',
}

export function addWaterSound(){
    if(!waterIsPlaying){
        water.fade(0, 0.5, 2000);
        water.play();
        waterIsPlaying = true;
    }
}

export function removeWaterSound(){
    if(waterIsPlaying){
        water.fade(0.5, 0, 2000);
        waterIsPlaying = false;
    }
}

export function changeSound(snd) {
    consoleLogger("Try to play sound: " + snd + ", currentSound: " + currentSound);
    
    if(snd === currentSound){
        //console.warn("Already playing " + currentSound);
        return;
    }
    
    //fade out existing sound
    if (currentSound) {
        //consoleLogger("fade out " + currentSound);
        var oldSoundObj = getSoundObj(currentSound);
        //consoleLogger(oldSoundObj);
        oldSoundObj.fade(1, 0, 2000);
    }

    /*
    var newSoundObj = getSoundObj(snd);
    consoleLogger(newSoundObj);
    
    //fade in and play current sound
    newSoundObj.play();
    newSoundObj.fade(0, 1, 2000);
    */

    switch (snd) {
        case sounds.INTRO:
            intro.play();
            intro.fade(0, 1, 2000);
            break;

        case sounds.TRAIN:
            train.play();
            train.fade(0, 1, 2000);
            break;

        case sounds.ENDING:
            ending.play();
            ending.fade(0, 1, 2000);
            break;
    }


    //set the new currentSound
    currentSound = snd;
}

export function checkSoundsReady() {

    let soundsReady = false;
    if(soundsPreloaded >= 2){
        soundsReady = true;
    }
    return soundsReady;
}

export function initSound() {

    intro = new Howl({
        src: ['assets/audio/intro.mp3'],
        autoplay: false,
        loop: true
    });

    
    intro.once('load', function(){
        consoleLogger("INTRO SOUND LOADED");
        soundsPreloaded += 1;
    });

    intro.on('fade', function (e) {
        //consoleLogger("on fade > intro vol is: " + intro._volume);
        if(intro._volume === 0){
            intro.pause();
        }
    });

    water = new Howl({
        src: ['assets/audio/water.mp3'],
        autoplay: false,
        loop: true,
        volume: 0.5
    });


    water.once('load', function(){
        consoleLogger("WATER SOUND LOADED");
        soundsPreloaded += 1;
    });

    water.on('fade', function (e) {
        //consoleLogger("on fade > water vol is: " + water._volume);
        if(water._volume === 0){
            water.pause();
        }
    });

    train = new Howl({
        src: ['assets/audio/train.mp3'],
        autoplay: false,
        loop: true
    });

    train.on('fade', function (e) {
        //consoleLogger("on fade > train vol is: " + train._volume);
        if(train._volume === 0){
            train.pause();
        }
    });

    ending = new Howl({
        src: ['assets/audio/theme-four.mp3'],
        autoplay: false,
        loop: true
    });
    ending.on('fade', function (e) {
        //consoleLogger("on fade > ending vol is: " + ending._volume);
        if(ending._volume === 0){
            ending.pause();
        }
    });

}

function consoleLogger(msg){
    //consoleLogger(msg);
}

function getSoundObj(snd){
    var soundObj;
    switch (snd) {
        case sounds.INTRO:
            soundObj = intro;
            break;

        case sounds.WATER:
            soundObj = water;
            break;

        case sounds.TRAIN:
            soundObj = train;
            break;

        case sounds.ENDING:
            soundObj = ending;
            break;
    }
    return soundObj;
}
